import { Dispatch } from 'redux';

import { toggleNetworkConnectivity } from '../ducks/ui';

// Updates Redux store based on the network connectivity.
export const detectOfflineState = (dispatch: Dispatch): void => {
  window.addEventListener('offline', () => dispatch(toggleNetworkConnectivity({ isOffline: true })));
  window.addEventListener('online', () => dispatch(toggleNetworkConnectivity({ isOffline: false })));
};
